const ArgumentType = require('../../extension-support/argument-type');
const BlockType = require('../../extension-support/block-type');
const Cast = require('../../util/cast');

class Scratch3CyberRobot {
    constructor(runtime) {
        this.runtime = runtime;
        this.energy = 100;

        this.client    = null;
        this.connected = false;
        this.mqttLib   = null;

        this._connectTimeoutHandle = null;
        this._connectTimeoutMs = 10000;

        this.connectionStatus = 'chưa kết nối';

        this.teamCenter = '';
        this.teamCenterTopic = 'team/center';
        this.teamResponseTopic = 'team/center/response';

        this.minerTopic = '';

        this.teamCode = '';
        this.teamName = '';
        this.teamStatus = 'chưa kiểm tra';
        this.teamExists = false;

        this.lastRequestTime = 0;
        this.requestCooldownMs = 2000;

        this.joinCode = '';
        this.teamToken = '';
        this.teamStatus = 'chưa tham gia team';

        this.pendingTeamChecks = new Map();
        this.teamExists = false;

        this.teamATTACKER_CODE = '';

        this.pendingGetTeams = null;

        this.teamListReplyTopic = 'team/client/team-list';
        this.pendingGetTeams = new Map();

        // =====================================================
        // MQTT CLOUD CONFIG
        // =====================================================
        this.defaultHost = 'unicorn.cusc.vn';
        this.defaultPort = 443;
        this.defaulUser = 'unicorn';
        this.defaultPass = '123456';

        this.ready = this._loadMQTT();
    }

    getInfo() {
        return {
            id: 'cyberrobot',
            name: 'Cybersecurity',

            color1: '#FF5252',
            color2: '#D32F2F',
            color3: '#B71C1C',

            blocks: [
                // {
                //     opcode: 'sayHello',
                //     blockType: BlockType.COMMAND,
                //     text: 'robot nói xin chào'
                // },

                // -------------------------------------------------
                // ROBOT CLOUD
                // -------------------------------------------------

                // {
                //     opcode: 'connectMQTT',
                //     blockType: BlockType.COMMAND,

                //     text:
                //         'Kết nối hệ thống [USER] pass [PASS]',

                //     arguments: {

                //         USER: {
                //             type: ArgumentType.STRING,
                //             defaultValue: 'unicorn'
                //         },

                //         PASS: {
                //             type: ArgumentType.STRING,
                //             defaultValue: '123456'
                //         }
                //     }
                // },

                {
                    opcode: 'connectMQTT',
                    blockType: BlockType.COMMAND,

                    text:
                        'Kết nối hệ thống.',

                },

                {
                    opcode: 'createTeam',
                    blockType: BlockType.COMMAND,

                    text:
                        'Khởi tạo team, mã [TEAM_CODE] tên [TEAM_NAME]',

                    arguments: {

                        TEAM_CODE: {
                            type: ArgumentType.STRING,
                            defaultValue: 'Team00'
                        },

                        TEAM_NAME: {
                            type: ArgumentType.STRING,
                            defaultValue: 'Cyber Robot'
                        }
                    }
                },

                {
                    opcode: 'joinTeam',
                    blockType: BlockType.COMMAND,

                    text: 'tham gia team [TEAM_CODE] mã [JOIN_CODE]',

                    arguments: {
                        TEAM_CODE: {
                            type: ArgumentType.STRING,
                            defaultValue: 'Team01'
                        },

                        JOIN_CODE: {
                            type: ArgumentType.STRING,
                            defaultValue: '000000'
                        }
                    }
                },

                {
                    opcode: 'transferTeam',
                    blockType: BlockType.COMMAND,

                    text: 'Chuyển data cho team [TARGET_TEAM]',

                    arguments: {
                        TARGET_TEAM: {
                            type: ArgumentType.STRING,
                            defaultValue: 'Team00'
                        },
                    }
                },


                {
                    opcode: 'attackTeam',
                    blockType: BlockType.COMMAND,

                    text: 'tấn công team [TEAM_CODE]',

                    arguments: {
                        TEAM_CODE: {
                            type: ArgumentType.STRING,
                            defaultValue: 'Team00'
                        },
                    }
                },

                {
                    opcode: 'minerTeam',
                    blockType: BlockType.COMMAND,

                    text: 'Đào dữ liệu',
                },

                {
                    opcode: 'getTeams',
                    blockType: BlockType.COMMAND,

                    text: 'Lấy danh sách Team',
                },

                {
                    opcode: 'getCurrentTeam',
                    blockType: BlockType.REPORTER,
                    text: 'team hiện tại'
                },
                {
                    opcode: 'getJoinCode',
                    blockType: BlockType.REPORTER,
                    text: 'mã tham gia team'
                },
                {
                    opcode: 'getTeamStatus',
                    blockType: BlockType.REPORTER,
                    text: 'trạng thái team'
                },

                {
                    opcode: 'isTeamExists',
                    blockType: BlockType.BOOLEAN,
                    text: 'Có tồn tại team [TEAM_CODE]?',
                    arguments: {
                        TEAM_CODE: {
                            type: ArgumentType.STRING,
                            defaultValue: 'Team00'
                        }
                    }
                },

                // {
                //     opcode: 'setEnergy',
                //     blockType: BlockType.COMMAND,
                //     text: 'đặt năng lượng thành [ENERGY]',
                //     arguments: {
                //         ENERGY: {
                //             type: ArgumentType.NUMBER,
                //             defaultValue: 100
                //         }
                //     }
                // },

                {
                    opcode: 'buyFirewall',
                    blockType: BlockType.COMMAND,

                    text: 'Mua tường bảo vệ (firewall)',
                },

                // {
                //     opcode: 'getEnergy',
                //     blockType: BlockType.REPORTER,
                //     text: 'năng lượng robot'
                // },
                {
                    opcode: 'isEnergyLow',
                    blockType: BlockType.BOOLEAN,
                    text: 'năng lượng thấp hơn [LEVEL]?',
                    arguments: {
                        LEVEL: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 20
                        }
                    }
                }
            ]
        };
    }

    // sayHello(args, util) {
    //     if (!util.target) {
    //         return;
    //     }

    //     this.runtime.emit(
    //         'SAY',
    //         util.target,
    //         'say',
    //         'Xin chào! Tôi là Cyber'
    //     );
    // }

    moveRobot(args, util) {
        const distance = Cast.toNumber(args.DISTANCE);

        if (!util.target) {
            return;
        }

        const direction = util.target.direction * Math.PI / 180;

        const newX =
            util.target.x +
            distance * Math.sin(direction);

        const newY =
            util.target.y +
            distance * Math.cos(direction);

        util.target.setXY(newX, newY);
    }

    setEnergy(args) {
        this.energy = Cast.toNumber(args.ENERGY);

        if (this.energy < 0) {
            this.energy = 0;
        }

        if (this.energy > 100) {
            this.energy = 100;
        }
    }

    getEnergy() {
        return this.energy;
    }

    isEnergyLow(args) {
        const level = Cast.toNumber(args.LEVEL);
        return this.energy < level;
    }

    _sanitizeTeamCode(value) {
        return String(value ?? '')
            .trim()
            .replace(/[^a-zA-Z0-9_-]/g, '')
            .substring(0, 32);
    }

    isTeamExists(args) {
        const teamCode = this._sanitizeTeamCode(
            args?.TEAM_CODE
        );

        if (!teamCode) {
            console.warn('[TEAM] Mã team không hợp lệ');
            return false;
        }

        if (!this.client || !this.connected) {
            console.warn('[TEAM] MQTT chưa kết nối');
            return false;
        }

        const responseTopic =
            `team/response/${teamCode}`;

        const requestId =
            `${this.clientId}_${Date.now()}`;

        const payload = {
            action: 'GET',
            requestId: requestId,
            clientId: this.clientId,

            team: {
                code: teamCode
            },

            timestamp: new Date().toISOString()
        };

        return new Promise(resolve => {
            const timeoutHandle = setTimeout(() => {
                this.pendingTeamChecks.delete(
                    requestId
                );

                console.warn(
                    '[TEAM] Hết thời gian chờ:',
                    teamCode
                );

                resolve(false);
            }, 5000);

            this.pendingTeamChecks.set(
                requestId,
                {
                    teamCode: teamCode,
                    resolve: resolve,
                    timeoutHandle: timeoutHandle
                }
            );

            // Subscribe trước khi gửi GET
            this.client.subscribe(
                responseTopic,
                {qos: 1},
                error => {
                    if (error) {
                        clearTimeout(timeoutHandle);

                        this.pendingTeamChecks.delete(
                            requestId
                        );

                        console.error(
                            '[TEAM] Subscribe lỗi:',
                            error
                        );

                        resolve(false);
                        return;
                    }

                    console.log(
                        '[TEAM] Đang nghe:',
                        responseTopic
                    );

                    this._publishJSON(
                        this.teamCenterTopic,
                        payload
                    );
                }
            );
        });
    }
    _notifyUser(util, message) {
        console.log('[CYBERSECURITY]', message);

        if (!util || !util.target) {
            return;
        }

        this.runtime.emit(
            'SAY',
            util.target,
            'say',
            message
        );
    }


    // =========================================================
    // INTERNAL: UPDATE TOPICS
    // =========================================================

    _updateTopics() {
        this.teamCenter =
            `team/${this.teamCode}`;

        this.teamControlTopic =
            `team/${this.teamCode}/control`;

        this.teamResourceTopic =
            `team/${this.teamCode}/resource`;

        this.teamStatusTopic =
            `team/${this.teamCode}/status`;

        console.log(
            '[TEAM] Center topic:',
            this.teamCenter
        );

        console.log(
            '[TEAM] Control topic:',
            this.teamControlTopic
        );

        console.log(
            '[TEAM] Resource topic:',
            this.teamResourceTopic
        );

        console.log(
            '[TEAM] Status topic:',
            this.teamStatusTopic
        );
    }

    // =========================================================
    // BLOCK: CREATE TEAM
    // =========================================================

    _canSendRequest(util) {
        const now = Date.now();

        if (
            now - this.lastRequestTime <
            this.requestCooldownMs
        ) {
            this._notifyUser(
                util,
                'Bạn thao tác quá nhanh. Hãy chờ 2 giây.'
            );

            return false;
        }

        this.lastRequestTime = now;
        return true;
    }

    createTeam(args, util) {
        const inputCode = String(
            args.TEAM_CODE
        )

        .trim()
        .replace(/[^a-zA-Z0-9_-]/g, '')
        .substring(0, 32);

        const inputName = Cast.toString(
            args.TEAM_NAME
        )
            .trim()
            .substring(0, 50);

        // Không cho phép dùng mã mặc định
        if (
            !inputCode ||
            inputCode.toLowerCase() === 'team00'
        ) {
            this.teamStatus =
                'Hãy thay đổi mã Team00';

            this._notifyUser(
                util,
                'Bạn chưa đổi mã team! Hãy thay Team00 bằng mã khác.'
            );

            return;
        }

        if (!this.client || !this.connected) {
            this.teamStatus =
                'chưa kết nối hệ thống';

            this._notifyUser(
                util,
                'Hãy kết nối hệ thống trước.'
            );

            return;
        }

        if (!this._canSendRequest(util)) {
            return;
        }

        if (!inputCode) {
            console.warn(
                '[ROBOT] Invalid Team Code'
            );
            return;
        }
        
        this.teamCode = inputCode;
        this.teamName = inputName;

        const payload = {
            ACTION: 'CREATE',

            TEAM_CODE: this.teamCode,
            TEAM_NAME: this.teamName,

            sender: 'scratch',
            timestamp: new Date().toISOString()
        };

        this.teamStatus = 'đang gửi yêu cầu tạo team';

        this._publishJSON(
            this.teamCenterTopic,
            payload
        );

        this._notifyUser(
            util,
            `Đang tạo team ${this.teamCode}`
        );
    }

    transferTeam(args, util) {
        const TARGET_TEAM = String(
            args.TARGET_TEAM
        )

        .trim()
        .replace(/[^a-zA-Z0-9_-]/g, '')
        .substring(0, 32);

        // Không cho phép dùng mã mặc định
        if (
            !TARGET_TEAM ||
            TARGET_TEAM.toLowerCase() === 'team00'
        ) {
            this.teamStatus =
                'Hãy thay đổi mã Team00';

            this._notifyUser(
                util,
                'Bạn chưa đổi mã team! Hãy thay Team00 bằng mã khác.'
            );

            return;
        }

        if (!this.client || !this.connected) {
            this.teamStatus =
                'chưa kết nối hệ thống';

            this._notifyUser(
                util,
                'Hãy kết nối hệ thống trước.'
            );

            return;
        }

        if (!this._canSendRequest(util)) {
            return;
        }

        if (!TARGET_TEAM) {
            console.warn(
                '[ROBOT] Invalid Team Code'
            );
            return;
        }
    
        const payload = {
            ACTION: 'TRANSFER',

            SOURCE_TEAM: this.teamCode,
            TARGET_TEAM: TARGET_TEAM,   
            DATA_AMOUNT: 50,

            sender: 'scratch',
            timestamp: new Date().toISOString()
        };

        this.teamStatus = 'đang chuyển dữ liệu cho team khác';

        this._publishJSON(
            this.teamCenterTopic,
            payload
        );

        this._notifyUser(
            util,
            `Đang chuyển dữ liệu cho team ${TARGET_TEAM}`
        );
    }

    attackTeam(args, util) {
        const teamATTACKER_CODE = String(
            args.TEAM_CODE
        )

        .trim()
        .replace(/[^a-zA-Z0-9_-]/g, '')
        .substring(0, 32);

        const inputName = Cast.toString(
            args.TEAM_NAME
        )
            .trim()
            .substring(0, 50);

        // Không cho phép dùng mã mặc định
        if (
            !teamATTACKER_CODE ||
            teamATTACKER_CODE.toLowerCase() === 'team00'
        ) {
            this.teamStatus =
                'Hãy thay đổi mã Team00';

            this._notifyUser(
                util,
                'Bạn chưa đổi mã team! Hãy thay Team00 bằng mã khác.'
            );

            return;
        }

        if (!this.client || !this.connected) {
            this.teamStatus =
                'chưa kết nối hệ thống';

            this._notifyUser(
                util,
                'Hãy kết nối hệ thống trước.'
            );

            return;
        }

        if (!this._canSendRequest(util)) {
            return;
        }

        if (!teamATTACKER_CODE) {
            console.warn(
                '[ROBOT] Invalid Team Code'
            );
            return;
        }
        
        this.teamATTACKER_CODE = teamATTACKER_CODE;

        const payload = {
            ACTION: 'ATTACK',

            ATTACK_SOURCE_TEAM: this.teamCode,
            ATTACK_TARGET_TEAM: this.teamATTACKER_CODE,

            sender: 'scratch',
            timestamp: new Date().toISOString()
        };

        this.teamStatus = 'đang gửi yêu cầu tạo team';

        this._publishJSON(
            this.teamCenterTopic,
            payload
        );

        this._notifyUser(
            util,
            `Đang tạo team ${this.teamCode}`
        );
    }

    getTeams(args, util) {
        if (!this.client || !this.connected) {
            window.alert('Hãy kết nối hệ thống trước.');
            return;
        }

        if (!this._canSendRequest(util)) {
            return;
        }


        const payload = {
            ACTION: 'GET_TEAMS',
            REPLY_TOPIC: this.teamListReplyTopic
        };

        return new Promise(resolve => {
            const timeoutHandle = setTimeout(() => {

                window.alert(
                    'Không nhận được danh sách team từ máy chủ.'
                );

                resolve();
            }, 5000);

            // Đăng ký topic nhận phản hồi trước khi gửi yêu cầu
            this.client.subscribe(
                this.teamListReplyTopic,
                {qos: 1},
                error => {
                    if (error) {
                        clearTimeout(timeoutHandle);

                        console.error(
                            '[GET_TEAMS] Subscribe lỗi:',
                            error
                        );

                        window.alert(
                            'Không thể đăng ký topic nhận danh sách team.'
                        );

                        resolve();
                        return;
                    }

                    console.log(
                        '[GET_TEAMS] Đang nghe topic:',
                        this.teamListReplyTopic
                    );

                    this._publishJSON(
                        this.teamCenterTopic,
                        payload
                    );
                }
            );
        });
    }

    minerTeam(args, util) {

        if (!this.client || !this.connected) {
            this.teamStatus =
                'chưa kết nối hệ thống';

            this._notifyUser(
                util,
                'Hãy kết nối hệ thống trước.'
            );

            return;
        }

        if (!this._canSendRequest(util)) {
            return;
        }

        const teamMiner = this.teamCode;

        if (!teamMiner) {
            console.warn(
                'Bạn chưa tham gia team nào.'
            );
            return;
        }
        
        const payload = {
            ACTION: 'MINER',
        };

        this.minerTopic = `team/${teamMiner}/miner`;

        this._publishJSON(
            this.minerTopic,
            payload
        );

        this._notifyUser(
            util,
            `Đang khai thác ${this.teamCode}`
        );
    }

    joinTeam(args, util) {
        const teamCode = Cast.toString(
            args?.TEAM_CODE ?? ''
        )
            .trim()
            .replace(/[^a-zA-Z0-9_-]/g, '')
            .substring(0, 32);

        const joinCode = Cast.toString(
            args?.JOIN_CODE ?? ''
        )
            .trim()
            .replace(/[^0-9]/g, '')
            .substring(0, 8);

        if (!teamCode) {
            this._notifyUser(
                util,
                'Mã team không hợp lệ.'
            );
            return;
        }

        if (joinCode.length !== 6) {
            this._notifyUser(
                util,
                'Mã tham gia phải có đúng 6 số.'
            );
            return;
        }

        if (!this.client || !this.connected) {
            this._notifyUser(
                util,
                'Hãy kết nối hệ thống trước.'
            );
            return;
        }

        if (
            typeof this._canSendRequest === 'function' &&
            !this._canSendRequest(util)
        ) {
            return;
        }

        if (!this.clientId) {
            this.clientId =
                `scratch_${Math.random()
                    .toString(16)
                    .slice(2, 10)}`;
        }

        // Gán mã team trước
        this.teamCode = teamCode;

        if (!this.teamRequestTopic) {
            this.teamRequestTopic =
                `team/request/${this.teamCode}`;
        }

        const requestId =
            `${this.clientId}_${Date.now()}`;

        const payload = {
            action: 'JOIN',
            requestId,
            clientId: this.clientId,

            team: {
                code: teamCode
            },

            joinCode,

            timestamp: new Date().toISOString()
        };

        this.teamCode = teamCode;
        this.teamStatus = 'đang tham gia team';

        this._publishJSON(
            this.teamRequestTopic,
            payload
        );

        this._notifyUser(
            util,
            `Đang tham gia ${teamCode}`
        );
    }

    buyFirewall(args, util) {
        if (!this.client || !this.connected) {
            this.teamStatus =
                'chưa kết nối hệ thống';

            this._notifyUser(
                util,
                'Hãy kết nối hệ thống trước.'
            );

            return;
        }

        if (!this._canSendRequest(util)) {
            return;
        }

        const teamMiner = this.teamCode;

        if (!teamMiner) {
            console.warn(
                'Bạn chưa tham gia team nào.'
            );
            return;
        }
        
        const payload = {
            ACTION: 'BUY_FIREWALL',

            TEAM_CODE: this.teamCode,
            "COST": 50,

            sender: 'scratch',
            timestamp: new Date().toISOString()
        };;

        this._publishJSON(
            this.teamCenterTopic,
            payload
        );

        this._notifyUser(
            util,
            `Đang mua tường bảo vệ ${this.teamCode}`
        );
    }

    getJoinCode() {
        return this.joinCode || 'chưa có';
    }

    getTeamStatus() {
        return this.teamStatus;
    }

    _loadMQTT() {
        return new Promise((resolve, reject) => {
            if (window.mqtt) {
                this.mqttLib = window.mqtt;

                console.log('[ROBOT] MQTT library already loaded');

                resolve();
                return;
            }

            const script = document.createElement('script');

            script.src =
                'https://unpkg.com/mqtt/dist/mqtt.min.js';

            script.onload = () => {
                this.mqttLib = window.mqtt;

                console.log('[ROBOT] MQTT library loaded');

                resolve();
            };

            script.onerror = () => {
                console.error(
                    '[ROBOT] Cannot load MQTT library'
                );

                reject(
                    new Error('Cannot load MQTT library')
                );
            };

            document.head.appendChild(script);
        });
    }

    getCurrentTeam() {
        return this.teamCode || 'chưa có';
    }

    _publishJSON(topic, data) {
        if (!this.client || !this.connected) {
            console.warn(
                '[MQTT] Cannot publish JSON: not connected'
            );

            return false;
        }

        let message = '';

        try {
            message = JSON.stringify(data);
        } catch (error) {
            console.error(
                '[MQTT] JSON encode error:',
                error
            );

            return false;
        }

        this.client.publish(
            topic,
            message,
            {
                qos: 1,
                retain: false
            },
            error => {
                if (error) {
                    console.error(
                        '[MQTT] Publish JSON error:',
                        error
                    );

                    return;
                }

                console.log(
                    '[MQTT] JSON published:',
                    topic,
                    message
                );
            }
        );

        return true;
    }

    // =========================================================
    // INTERNAL: CLEAR TIMEOUT
    // =========================================================

    _clearConnectTimeout() {
        if (this._connectTimeoutHandle) {
            clearTimeout(
                this._connectTimeoutHandle
            );
            this._connectTimeoutHandle = null;
        }
    }

    _handleIncomingMessage(topic, message) {
        console.log(
            '[MQTT] Message received:',
            topic,
            message
        );

        let data;

        try {
            data = JSON.parse(message);
        } catch (error) {
            console.warn(
                '[MQTT] Invalid JSON:',
                message
            );
            return;
        }

        // =====================================================
        // NHẬN DANH SÁCH TEAM
        // =====================================================
        if (topic === this.teamListReplyTopic) {
            this._handleTeamListResponse(data);
            return;
        }

        // =====================================================
        // NHẬN PHẢN HỒI TEAM THÔNG THƯỜNG
        // =====================================================
        if (topic !== this.teamResponseTopic) {
            return;
        }

        if (
            data.teamCode &&
            this.teamCode &&
            data.teamCode !== this.teamCode
        ) {
            return;
        }

        if (data.action === 'GET') {
            this.teamExists = Boolean(data.exists);

            if (this.teamExists) {
                this.teamStatus =
                    `team ${data.teamCode} đã tồn tại`;

                this.teamCode = data.teamCode;

                if (data.team && data.team.name) {
                    this.teamName = data.team.name;
                }

                this._updateTopics();
            } else {
                this.teamStatus =
                    `không tìm thấy team ${data.teamCode}`;
            }
        }

        if (data.action === 'CREATE') {
            if (data.success) {
                this.teamExists = true;

                this.teamStatus =
                    `đã tạo team ${data.teamCode}`;

                this.teamCode =
                    data.teamCode || this.teamCode;

                if (data.team && data.team.name) {
                    this.teamName = data.team.name;
                }

                this._updateTopics();
            } else {
                this.teamExists = false;

                this.teamStatus =
                    data.message ||
                    'không thể tạo team';
            }
        }
    }

    // =========================================================
    // BLOCK: CONNECT MQTT
    // =========================================================
    connect(args) {
        return new Promise(async resolve => {
            try {
                console.log("Hello1")
                await this.ready;
                if (!this.mqttLib) {
                    console.error(
                        '[ROBOT] Library not ready'
                    );
                    return resolve();
                }

                console.log("Hello2")

                // ------------------------------------------------
                // Destroy old client
                // ------------------------------------------------

                if (this.client) {
                    this.client.removeAllListeners();
                    this.client.end(true);
                    this.client    = null;
                    this.connected = false;
                }

                // ------------------------------------------------
                // ws / wss
                // ------------------------------------------------

                const protocol =
                    args.SECURE === false
                        ? 'ws'
                        : 'wss';

                const url =
                    `${protocol}://${args.HOST}:${args.PORT}/mqtt`;

                console.log(
                    '[ROBOT] Connecting:',
                    url
                );

                // ------------------------------------------------
                // OPTIONS
                // ------------------------------------------------

                const options = {

                    username:
                        args.USER || undefined,

                    password:
                        args.PASS || undefined,

                    reconnectPeriod: 3000,

                    connectTimeout:
                        this._connectTimeoutMs,

                    keepalive: 20,
                    clean: true,
                    resubscribe: false
                };

                this.client =
                    this.mqttLib.connect(
                        url,
                        options
                    );

                // ------------------------------------------------
                // TIMEOUT
                // ------------------------------------------------

                this._connectTimeoutHandle =
                    setTimeout(() => {
                        if (!this.connected) {
                            console.error(
                                '[ROBOT] Connect timeout'
                            );
                            resolve();
                        }

                    },
                    this._connectTimeoutMs
                );

                // ------------------------------------------------
                // CONNECT
                // ------------------------------------------------

                this.client.on('connect', () => {
                    this._clearConnectTimeout();
                    this.connected = true;
                    console.log(
                        '[ROBOT] Connected'
                    );

                    // ----------------------------------------
                    // Subscribe to sensor feedback topics
                    // ----------------------------------------

                    // this._subscribeToSensorTopics();

                    resolve();
                });

                // ------------------------------------------------
                // MESSAGE (incoming from robot)
                // ------------------------------------------------

                this.client.on('message', (topic, payload) => {
                    const msg = payload.toString().trim();
                    this._handleIncomingMessage(topic, msg);
                });

                // ------------------------------------------------
                // RECONNECT
                // ------------------------------------------------

                this.client.on('reconnect', () => {
                    this.connected = false;
                    console.log(
                        '[ROBOT] Reconnecting...'
                    );
                });

                // ------------------------------------------------
                // OFFLINE
                // ------------------------------------------------

                this.client.on('offline', () => {
                    this.connected = false;
                    console.warn(
                        '[ROBOT] Offline'
                    );
                });

                // ------------------------------------------------
                // CLOSE
                // ------------------------------------------------

                this.client.on('close', () => {
                    this.connected = false;
                    console.warn(
                        '[ROBOT] Connection closed'
                    );
                });

                // ------------------------------------------------
                // ERROR
                // ------------------------------------------------

                this.client.on('error', err => {
                    this._clearConnectTimeout();
                    this.connected = false;
                    console.error(
                        '[ROBOT] Error:',
                        err.message
                    );
                    resolve();
                });

            } catch (err) {
                this._clearConnectTimeout();
                console.error(
                    '[ROBOT] Connect failed:',
                    err
                );
                resolve();
            }
        });
    }

    connectMQTT(args) {
        return this.connect({
            HOST: this.defaultHost,
            PORT: this.defaultPort,
            // USER: args.USER,
            // PASS: args.PASS,
            USER: this.defaulUser,
            PASS: this.defaultPass,
            SECURE: true
        });
    }

    // =========================================================
    // INTERNAL: PUBLISH HELPER
    // =========================================================

    _publish(topic, msg) {

        if (!this.client || !this.connected) {
            console.warn(
                '[ROBOT] Not connected'
            );
            return;
        }

        this.client.publish(
            topic,
            msg,
            { qos: 1 },
            err => {
                if (err) {
                    console.error(
                        '[ROBOT] Publish error:',
                        err
                    );
                    return;
                }
                console.log(
                    '[ROBOT] Published:',
                    topic,
                    msg
                );
            }
        );
    }

    // =========================================================
    // INTERNAL: SUBSCRIBE TO SENSOR FEEDBACK TOPICS
    // =========================================================

    _subscribeToSensorTopics() {

        if (!this.client || !this.teamCode) return;

        this.client.subscribe(
            this.ultraDataTopic,
            { qos: 1 },
            err => {

                if (err) {

                    console.error(
                        '[ROBOT] Subscribe error (ultra/data):',
                        err
                    );

                    return;
                }

                console.log(
                    '[ROBOT] Subscribed:',
                    this.ultraDataTopic
                );
            }
        );
    }
}

module.exports = Scratch3CyberRobot;